<template>
  <div id="chartDom" style="height: 100%; width: 100%"></div>
</template>

<script>
import * as echart from 'echarts';
import { DUO_CHART_TYPE } from '@/helpers/constant';

export default {
  name: 'Chart',
  props: {
    chartData: {
      type: Array,
      default: () => {},
    },
    activeChartType: {
      type: String,
      default: () => {},
    },
  },
  data() {
    return {
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        legend: {
          data: [],
        },
        xAxis: [
          {
            type: 'category',
            name: 'Thời gian',
            data: [],
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: 'Phần trăm tham gia lớp học',
            min: 0,
            max: 100,
            interval: 50,
            axisLabel: {
              formatter: (value) => `${parseFloat(value).toFixed(0)} %`,
            },
          },
        ],
        series: [
        ],
      },
      chartDom: null,
      myChart: null,
    };
  },
  computed: {
    chartOptions() {
      const chartOptions = _.cloneDeep(this.options);
      if (this.chartData) {
        const dataChart = this.chartData.find((e) => e.type === this.activeChartType);
        if (this.activeChartType === DUO_CHART_TYPE.JOIN_CLASS_RATE) {
          chartOptions.yAxis[0] = {
            type: 'value',
            name: 'Phần trăm tham gia lớp học',
            min: 0,
            max: 100,
            interval: 50,
            axisLabel: {
              formatter: (value) => `${parseFloat(value).toFixed(0)} %`,
            },
          };
          chartOptions.tooltip.valueFormatter = (value) => `${value.toFixed(0)} %`;
        } else if (this.activeChartType === DUO_CHART_TYPE.AVERAGE_SCORE) {
          chartOptions.yAxis[0] = {
            type: 'value',
            name: 'Điểm trung bình',
            min: 0,
            max: 10,
            interval: 5,
            axisLabel: {
              formatter: (value) => `${parseFloat(value).toFixed(1)} đ`,
            },
          };
          chartOptions.tooltip.valueFormatter = (value) => `${value.toFixed(1)} đ`;
        }
        chartOptions.xAxis[0].data = dataChart.timeline;
        chartOptions.series = [];
        dataChart.series.forEach((item) => {
          chartOptions.series.push({
            name: item.name,
            type: 'bar',
            data: item.data,
          });
        });
      }
      return chartOptions;
    },
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.myChart.setOption(this.chartOptions, true);
      },
    },
    activeChartType() {
      this.myChart.setOption(this.chartOptions, true);
    },
    showLoading() {
      this.myChart.showLoading();
    },
    hideLoading() {
      this.myChart.hideLoading();
    },
    // isLoading(val) {
    //   if (val) {
    //     this.myChart.showLoading();
    //   } else {
    //     this.myChart.hideLoading();
    //   }
    // },
  },
  mounted() {
    this.chartDom = document.getElementById('chartDom');
    this.myChart = echart.init(this.chartDom);
    this.myChart.setOption(this.chartOptions);
  },
};
</script>

<style scoped>

</style>
